export const trimCharacter = (character?: string | null) => {
  if (character === null) return null;
  return character?.trim();
};
